// Build Recently Viewed List

// Get Current Product

let currentProduct = ''

if (document.querySelector('.main-product-section')) {
  currentProduct = document.querySelector('.main-product-section').dataset.productHandle;
}


//Retrieve Existing Products
let recentlyViewed = localStorage.getItem('recentlyViewed') || '[]';
recentlyViewed = JSON.parse(recentlyViewed);

// Get Array Length
let arrayLength = recentlyViewed.length;

// If Current Product is not already in Array
if (currentProduct.length > 0) {
  if (!recentlyViewed.includes(currentProduct)) {
    // If there are less than 4 elements in the Array, add product to end of Array
    if(arrayLength <= 3) {
      recentlyViewed.push(currentProduct);
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    } else {
      // If there are more than 4 elements in the Array, remove first product, and add product to end of Array
      recentlyviewed = recentlyViewed.shift();
      recentlyViewed.push(currentProduct);
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    }  
  }
}


class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    let recentlyViewedSection = document.querySelector('recently-viewed');

    if (recentlyViewed.length > 0 && recentlyViewedSection) {
      this.buildRecentlyViewed(recentlyViewedSection);
    } else {
      recentlyViewedSection.closest('.collection').style.display = 'none'
    }
  }

  buildRecentlyViewed(recentlyViewedSection) {

    let productURLs = []    
    recentlyViewed.forEach(el => {
      productURLs.push('/products/'+ el +'?view=product-json')
    });
  
    Promise.all(productURLs.map(url =>
      fetch(url)
      .then(response => response.json())
    ))
    .then(data => {
      return populateData(data);
    })

    function populateData(data) {
      data.forEach(product => {

        let template = document.querySelector(".card-template");
        let templateHtml = template.innerHTML;
        let content = "";
        let lowercaseTags = product.tags.map(tag => tag.toLowerCase());
        let price = "";
        if(lowercaseTags.includes('price on request')) {
          price = window.productStrings.priceOnRequest;
        } else {
          price = Shopify.formatMoney(product.price, window.moneyFormat.format);
        }

        content = templateHtml;
        content = templateHtml.replaceAll(/productUrl/g, product.url || '')
                              .replaceAll(/productTitle/g, product.title || '')
                              .replaceAll(/productImage/g, product.primary_image || '')
                              .replaceAll(/productAlt/g, product.alt || '')
                              .replaceAll(/productExcerpt/g, product.excerpt || '')
                              .replaceAll(/productPrice/g, price || '');
        
        // Replace the HTML with final HTML
        recentlyViewedSection.querySelector('ul').innerHTML += content;

      })
    }

  }
}

customElements.define('recently-viewed', RecentlyViewed);